import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as OrderCodeActions from './order-code.actions';
import { OrderCodeApiService } from './order-code.api.service';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { TranslationService } from '@core/services/common/translation.service';

@Injectable()
export class OrderCodeEffects {
  constructor(
    private actions$: Actions,
    private api: OrderCodeApiService,
    public ts: TranslationService,
  ) {}

  loadOrderCode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderCodeActions.loadOrderCode, OrderCodeActions.retryLoadOrderCode),
      mergeMap(() =>
        this.api.getNewOrderCode().pipe(
          map((response) => OrderCodeActions.loadOrderCodeSuccess({ response })),
          catchError((error) => {
            this.api.showOrderCodeErrorAlert();
            return of(OrderCodeActions.loadOrderCodeFailure({ error }));
          }),
        ),
      ),
    ),
  );
}
